module.exports = "/virtual-football-league/img/amblems/right/logos/FakeAstonVilla.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/FakeAstonVilla.png
// module id = 2173
// module chunks = 4